export default {
    allConsentGranted(granted) {
        gtag('consent', 'update', {
            'ad_user_data': granted,
            'ad_personalization': granted,
            'ad_storage': granted,
            'analytics_storage': granted
        });
    }
}


// WEBPACK FOOTER //
// ./src/functions/google.js